module.exports = __webpack_public_path__ + "media/images/icons/material/dollar-5e06fcb2066ef81daad9c42c012dd464.svg";